var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-zoom-container",on:{"mousemove":_vm.handleMouseMove,"mouseleave":_vm.handleMouseLeave,"wheel":_vm.handleWheel}},[_c('img',{ref:"image",class:'zoom-image max-h-[75vh] ' + _vm.classes,style:(_vm.imageStyle),attrs:{"src":_vm.src,"alt":_vm.alt},on:{"click":_vm.clickZoom}})])
}
var staticRenderFns = []

export { render, staticRenderFns }